import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Checkbox extends React.Component {
  constructor(props) {
    super(props)

    this.config = { 
      types : [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [ 
        'inverse'
      ],
      states : []
    }

  }

  render() {
    const { id, parentId, className, parentClassName, name, value, children, disabled, checked, onChange, onClick, parentProps, ...rest } = this.props
    return <div id={parentId} className={resolveProps(this.props, this.config, 'Checkbox') + ' ' + (parentClassName || '')} {...parentProps} >
      <input
        {...rest}
        onChange={onChange}
        type="checkbox"
        id={id}
        name={name || id}
        className={'mdn-Checkbox-input ' + (className || '')}
        value={value}
        checked={checked}
        disabled={disabled}
      />
      <label className="mdn-Checkbox-label" htmlFor={id}></label>
      <label className="mdn-Checkbox-text" htmlFor={id}>{children}</label>
    </div>
  }
}

Checkbox.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.node,
  disabled : PropTypes.bool,
  config : PropTypes.object
}